import { Component, OnInit, HostListener } from '@angular/core';
import { Filter } from '../models/filter.model';
import { FilterService } from './filter.service';
import { DataService } from 'src/app/shared/data.service';
declare var $: any;
@Component({
  selector: 'app-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.css']
})
export class FiltersComponent implements OnInit {
  searchFilters: Filter[];
  resultFilters: Filter[];
  searchTimeout: any;
  constructor(private filterService: FilterService, private dataService: DataService) { }

  ngOnInit() {
    this.searchFilters = this.filterService.getSearchFilters();
    this.resultFilters = this.filterService.getResultFilters();
  }

  updateSearchFilter(filterExpression: string, event) {
    const checked = event.target.checked;
    var filterToUpdate = this.searchFilters.find(x => x.Expression === filterExpression);
    filterToUpdate.Checked = checked;
    this.filterService.updateSearchFilter(filterExpression, checked);
    this.dataService.doSearch();
  }
  updateResultFilter(filterExpression: string, event) {
    const checked = event.target.checked;
    var filterToUpdate = this.resultFilters.find(x => x.Expression === filterExpression);
    filterToUpdate.Checked = checked;
    this.filterService.updateResultFilter(filterExpression, checked);
    this.resultFilters = this.resultFilters.slice(0);
  }
  doSearch(){
     this.dataService.doSearch();
   }
}
